import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      stroke: "#000",
      d: "M6.987 2.586a1.302 1.302 0 0 1 2.025 0c.324.4.853.573 1.35.439.801-.215 1.597.362 1.64 1.19.026.515.353.965.834 1.15a1.302 1.302 0 0 1 .626 1.925c-.281.432-.281.989 0 1.42.452.695.148 1.63-.626 1.926a1.302 1.302 0 0 0-.835 1.15 1.302 1.302 0 0 1-1.638 1.19 1.302 1.302 0 0 0-1.35.438 1.302 1.302 0 0 1-2.026 0 1.302 1.302 0 0 0-1.35-.439 1.302 1.302 0 0 1-1.639-1.19 1.302 1.302 0 0 0-.835-1.149 1.302 1.302 0 0 1-.625-1.926c.28-.431.28-.988 0-1.42a1.302 1.302 0 0 1 .625-1.926c.481-.184.809-.634.835-1.149a1.302 1.302 0 0 1 1.639-1.19 1.302 1.302 0 0 0 1.35-.439Z"
    }, null, -1)
  ]))]))
}
export default { render: render }